module.exports = __webpack_public_path__ + "img/00037.2fb96df0.webp";